<template>
  <div v-hotkey="keymap" ref="optionsPane" class="options-pane">
    <div class="accordion-header" v-if="showPaneMargin">
      <!--<div class="btn-sm accordion-toggle-btn"  @click="togglePaneOpen($event)">אפשרויות ניקוד</div>-->
      <b-button class="btn-sm accordion-toggle-btn" block @click="togglePaneOpen($event)" v-bind:class="{ active: paneOpen }">
        <div>אפשרויות ניקוד</div>
        <div v-if="!paneOpen"><i-caret-up></i-caret-up></div>
        <div v-else><i-caret-down></i-caret-down></div>
      </b-button>
    </div>
    <div v-if="paneOpen" class="options-pane-body">
      <div v-if="optionsToShow.length == 0 && nakdanStyle.Mobile" class="text-center text-muted pt-4">
        כדי לערוך ניקוד,
        <br/>
        יש ללחוץ על מילה מתוך הטקסט
      </div>
      <div class="morph-switch" v-if="showPaneMargin">
          <span @click.prevent="modesObj.showMorph = !(modesObj.showMorph)">
            <b-form-checkbox 
              v-bind:checked="showMorph"
              switch> פרוט מורפולוגי</b-form-checkbox>
          </span>
      </div>
      <div class="options-list-box-container" v-bind:class="{'list-box-container-margin': showPaneMargin, frame: showPaneMargin, 'list-box-container-mobile': nakdanStyle.Mobile, 'small-min-height': smallMinHeight, 'reg-min-height': !smallMinHeight}">
        <div v-show="localCurrentWordIndex > -1 && currentLetterNotSep" class="options-list-container">
          <div v-for="(option, o) in optionsToShow" 
            v-bind:id="'option-row-' + o"
            @click="optionClicked(o, $event)"
            @dblclick="optionClicked(o, $event)"
            @mouseover="hoveredOption = o" @mouseout="hoveredOption = -1"
            class="option-row clickable-option-row"
            v-bind:class="{
              'row-mobile': nakdanStyle.Mobile,
              'pt-3': showMorph, 
              'highlighted-row': (workingOption === o) && matchesChosen(option), 
              'framed-row': (workingOption === o) && !(matchesChosen(option)), 
              'hovered-option': o === hoveredOption, 
              'from-user-dict-negatives': implementUserAccounts && option.fromUserDictionaryNegatives }"
            :key="o">
            <div v-if="implementUserAccounts" style="float:left">
              <span 
                v-show="(o === hoveredOption) && (o >= relevantOptionsFromUserDictionary.length) && (o < optionsToShow.length - relevantNegativeOptionsFromUserDictionary.length)" 
                class="click-only-here"
                @click.stop="moveShownOptionToEnd('bottom', o)">
                <span class="dictionary-button"><i class="fa fa-sort-amount-down"></i></span>
              </span>
              <span 
                v-show="(o === hoveredOption) && (o !== 0 || !(relevantOptionsFromUserDictionary.length))" 
                class="click-only-here"
                @click.stop="moveShownOptionToEnd('top', o)">
                <span class="dictionary-button" v-show="o < relevantOptionsFromUserDictionary.length"><i-arrow-up></i-arrow-up></span>
                <span class="dictionary-button" v-show="o >= relevantOptionsFromUserDictionary.length && o < optionsToShow.length - relevantNegativeOptionsFromUserDictionary.length">
                  <i-star></i-star>
                </span>
              </span>
              <span v-show="o < relevantOptionsFromUserDictionary.length" class="dictionary-button"
                @click.stop="removeFromUserDictionary(option.displayText); initWorkingOption()"><i-star :solid="true"></i-star></span>
              <span v-show="o === hoveredOption && o >= optionsToShow.length - relevantNegativeOptionsFromUserDictionary.length" class="dictionary-button"
                @click.stop="removeFromUserDictionaryNegatives(option.displayText); initWorkingOption()"><i class="fa fa-sort-amount-up-alt"></i></span>
            </div>
            <p><span class="option-letter" v-html="optionKey(o)"></span><span style="color: red" v-html="getPrefixHTML(option)"></span><span v-html="getAfterPrefixHTML(option)"></span></p>
            <div v-if="showMorph" class="morph">
              <p class="mb-0" v-for="(morphLine, mli) in prettyPrintedMorphArray(option.morphArray)" :key="mli" v-html="morphLine"></p>
            </div>
          </div>
        </div>
      </div>
      <a id="applyToAllLink" 
        href="#"
        class="clickable-link"
        v-if="showPaneMargin"
        @click="showApplyToAllPopup = true">החל על כל הטקסט
      </a>
      <div v-if="nakdanStyle.Mobile" class="save-changes-footer">
        <b-button
          id="apply-button"
          size="lg" block
          @click="useNewChoice(); modesObj.multiPaneOpen = false"
          variant="primary">שמור שינויים
        </b-button>
      </div>
    </div>
    <b-modal v-model="showApplyToAllPopup"
             ok-title="החל"
             cancel-title="ביטול"
             @ok="applyToEntireText"
             centered
             size="sm"
    >
      <template slot="modal-header"><div> החל על כל הטקסט</div></template>
      <b-form-radio id="doBelow" value="below" v-model="applyToAllMode"> החל ממילה זו והלאה</b-form-radio>
      <b-form-radio id="doUnedited" value="unedited" v-model="applyToAllMode"> החל רק על מילים שלא נערכו</b-form-radio>
      <b-form-radio id="doAll" value="all" v-model="applyToAllMode"> החל על כל הטקסט</b-form-radio>
    </b-modal>
    <div class="nikud-options-account-needed-popup click-only-here" v-show="showAccountNeededPopup">
      text will be filled in dynamically
    </div>
  </div>
</template>

<script>

import nikudOptionsPaneKeyMap from '@/mixins/nikudOptionsPaneKeyMap'
import nikudMixins from '@/mixins/nikudMixins'
import morphMethods from '@/mixins/morphMethods'
import $ from 'jquery'
import serviceMixins from '@/mixins/serviceMixins'
import scrollParentToChild from '../js/scrollParentToChild'
import navigationMixins from '@/mixins/navigationMixins'
import wordMutatingMixins from '@/mixins/wordMutatingMixins'
import {SimpleVsProConfig} from '@/simpleVsProConfig.js'
import {NakdanStyle, MobileVsDesktopConfig} from '@/mobileVsDesktopConfig.js'
import {getStandardLetterArray} from '../js/letterOperations'

const optionsPaneLetterKeyOrder = 'FSJLREIOVCXM' // duplicated in NikudOptionsPaneKeyMap
const optionsPaneNumberKeyOrder = '0123456789' // duplicated in NikudOptionsPaneKeyMap
// const KEEP_PUNCTUATION = true

export default {
  name: 'NikudOptionsPane',
  mixins: [
    nikudMixins, /* for localCurrentWordIndex, localCurrentLetterIndex,
                      localLetterAddingMode (in KeyMap), localNikudKeyboard (here AND KeyMap), 
                      currentLetterNotSep (here AND KeyMap), localCurrentWord (here AND KeyMap), 
                      modalOpen() (in keymap), display(), showChangedNikudMessage(), 
                      removeFromUserDictionaryNegatives(), getRelevantNegativeOptionsFromUserDictionary()
                      removeFromUserDictionary (here AND KeyMap), getRelevantOptionsFromUserDictionary() */
    wordMutatingMixins, // for rewriteWordOrWordsInWorkingArrayMethod() and changeAllAlikeWordsToNewNikud()
    nikudOptionsPaneKeyMap, // for keymap
    morphMethods, // for prettyPrintedMorphArray() [& getAllMorphStrings(), in KeyMap code commented at "this" time]
    serviceMixins, // for gtag()
    navigationMixins // for moveToNextWord()
  ],
  props: ['subPanesStatus', 'modesObj', 'editNikudProps'],
  data () {
    return {
      settingsOpen: false,
      useOnAllText: false,
      workingOption: -1,
      hoveredOption: -1,
      applyToAllMode: 'below',
      showApplyToAllPopup: false,
      showAccountNeededPopup: false
    }
  },
  computed: {
    showMorph () {
      return this.modesObj.showMorph
    },
    nakdanStyle () {
      return NakdanStyle // Mobile: window.innerWidth < 992, Desktop: window.innerWidth >= 992
    },
    showPaneMargin () {
      return MobileVsDesktopConfig.SHOW_MARGINS_WITH_PANES
    },
    implementUserAccounts () {
      return SimpleVsProConfig.IMPLEMENT_USER_ACCOUNTS
    },
    smallMinHeight () { // alternative to hiding nikud buttons when showing both panes
      const nikudButtonOptions = SimpleVsProConfig.NIKUD_BUTTONS
      const alwaysShowingButtons = nikudButtonOptions.SHOW_BY_DEFAULT && !(nikudButtonOptions.CAN_SHOW_OR_HIDE)
      return alwaysShowingButtons && this.subPanesStatus.manualOpen && this.subPanesStatus.optionsOpen
    },
    localShowAims () {
      return this.$store.state.postSubmissionOptions.showAims
    },
    paneOpen () {
      return this.subPanesStatus.optionsOpen
    },
    relevantOptionsFromUserDictionary () {
      if (this.implementUserAccounts && this.localCurrentWordIndex > -1) {
        var currentWordObj = this.localCurrentWord
        return this.getRelevantOptionsFromUserDictionary(currentWordObj)
      } else return []
    },
    relevantNegativeOptionsFromUserDictionary () {
      if (this.implementUserAccounts && this.localCurrentWordIndex > -1) {
        var currentWordObj = this.localCurrentWord
        return this.getRelevantNegativeOptionsFromUserDictionary(currentWordObj)
          .filter(dictOpt => this.localCurrentWord.options.map(wordOpt => wordOpt.displayText).includes(dictOpt))
      } else return []
    },
    optionsToShow () {
      if (this.localCurrentWordIndex > -1) {
        var options = []
        var currentWordObj = this.localCurrentWord
        this.relevantOptionsFromUserDictionary.forEach(e => {
          var indexInNakdanOptions = currentWordObj.options.map(o => o.displayText).indexOf(e)
          options.push({
            displayText: e,
            prefixEndIndex: -1,
            morphArray: indexInNakdanOptions === -1 ? [] : currentWordObj.options[indexInNakdanOptions].morphArray
          })
        })
        currentWordObj.options.forEach(o => {
          if (!(this.relevantOptionsFromUserDictionary.concat(this.relevantNegativeOptionsFromUserDictionary)
                .includes(o.displayText))) {
            options.push(Object.assign({}, o)) // shallow copy so POSSIBLE to add props without writing to state
          }
        })
        this.relevantNegativeOptionsFromUserDictionary.slice().reverse().forEach(e => {
          if (!(this.relevantOptionsFromUserDictionary.includes(e))) {
            var indexInNakdanOptions = currentWordObj.options.map(o => o.displayText).indexOf(e)
            options.push({
              displayText: e,
              prefixEndIndex: -1, // note: the below condition shouldn't be needed here; it's just a precaution
              morphArray: indexInNakdanOptions === -1 ? [] : currentWordObj.options[indexInNakdanOptions].morphArray,
              fromUserDictionaryNegatives: true
            })
          }
        })
        return options
      } else return []
    }
  },
  watch: {
    localCurrentWordIndex: function (newLocalCurrentWordIndex) {
      if (newLocalCurrentWordIndex !== -1) this.initWorkingOption()
    },
    showMorph: function (newShowMorph) {
      if (newShowMorph) {
        this.gtag("event", "change display", {
          'event_category': 'nikud options pane',
          'event_label': 'show morphology'
        })
      }
    }
  },
  methods: {
    matchesChosen (option) {
      return option.displayText === this.localCurrentWord.chosenWordString
    },
    togglePaneOpen () {
      this.subPanesStatus.optionsOpen = !(this.subPanesStatus.optionsOpen)
    },
    optionKey (optionIndex) {
      return (optionIndex < 
        ((this.localNikudKeyboard === 'old') ? optionsPaneLetterKeyOrder : optionsPaneNumberKeyOrder).length) 
          ? ((this.localNikudKeyboard === 'old') ? optionsPaneLetterKeyOrder : optionsPaneNumberKeyOrder)
            .charAt(optionIndex) : '&nbsp;'
    },
    getOptionSegmentHTML (o, optionSegmentText) {
      return this.display(
              this.localShowAims && o.displayVariants && o.displayVariants.replaceArgsIfShowingAims 
                ? optionSegmentText.replace(...(o.displayVariants.replaceArgsIfShowingAims)) 
                : optionSegmentText)
    },
    getPrefixHTML (o) {
      const prefixText = o.prefixEndIndex === -1 ? '' 
                                        : getStandardLetterArray(o.displayText).slice(0, o.prefixEndIndex).join('')
      return this.getOptionSegmentHTML(o, prefixText)
    },
    getAfterPrefixHTML (o) {
      const afterPrefixText = getStandardLetterArray(o.displayText).slice(Math.max(0, o.prefixEndIndex)).join('')
      return this.getOptionSegmentHTML(o, afterPrefixText)
    },
    optionClicked (o) {
      this.workingOption = o
      if (NakdanStyle.Desktop && o < this.optionsToShow.length - this.relevantNegativeOptionsFromUserDictionary.length) {
        this.useNewChoice()
        this.moveToNextWord()
      }
    },
    initWorkingOption () {
      var optionDisplays = this.optionsToShow.map(o => this.display(o.displayText))
      this.workingOption = optionDisplays.includes(this.localCurrentWord.chosenWordString)
        ? optionDisplays.indexOf(this.localCurrentWord.chosenWordString)
        : optionDisplays.indexOf(this.display(this.localCurrentWord.options[this.localCurrentWord.chosenOptionIndex].displayText))
      if (this.paneOpen) this.scrollOptionsList()
    },
    moveToNextOption () {
      if (this.workingOption < this.optionsToShow.length - 1) {
        this.workingOption += 1
        if (this.workingOption < this.optionsToShow.length - this.relevantNegativeOptionsFromUserDictionary.length) {
          this.useNewChoice()
        }
        if (this.paneOpen) this.scrollOptionsList()
      }
    },
    moveToPreviousOption () {
      if (this.workingOption > 0) {
        this.workingOption -= 1
        if (this.workingOption < this.optionsToShow.length - this.relevantNegativeOptionsFromUserDictionary.length) {
          this.useNewChoice()
        }
        if (this.paneOpen) this.scrollOptionsList()
      }
    },
    moveToFirstOption () {
      this.workingOption = 0
      this.useNewChoice()
      if (this.paneOpen) this.scrollOptionsList()
    },
    moveToLastOption () {
      this.workingOption = this.optionsToShow.length > this.relevantNegativeOptionsFromUserDictionary.length 
        ? this.optionsToShow.length - this.relevantNegativeOptionsFromUserDictionary.length - 1 : 0
      this.useNewChoice()
      if (this.paneOpen) this.scrollOptionsList()
    },
    changeWorkingOption (newOption) {
      if (newOption < this.optionsToShow.length) {
        this.workingOption = newOption
        this.useNewChoice()
        this.moveToNextWord()
      }
    },
    useNewChoice () {
      if (this.workingOption < this.relevantOptionsFromUserDictionary.length) {
        if (this.relevantOptionsFromUserDictionary[this.workingOption] !== this.localCurrentWord.chosenWordString) {
          this.rewriteWordOrWordsInWorkingArrayMethod({
            contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
            newWordContainer: {
              index: this.localCurrentWordIndex, changes: { 
                altered: true,
                choiceType: 'manual',
                manualNikud: this.relevantOptionsFromUserDictionary[this.workingOption]
              }
            }
          })
        }
      } else {
        var lookupIndex = this.localCurrentWord.options.map(o => this.display(o.displayText))
          .indexOf(this.display(this.optionsToShow[this.workingOption].displayText))
        if ((this.localCurrentWord.choiceType !== 'option')
            || (this.localCurrentWord.chosenOptionIndex !== lookupIndex)) {
          this.rewriteWordOrWordsInWorkingArrayMethod({
            contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
            newWordContainer: {
              index: this.localCurrentWordIndex, changes: { 
                altered: true,
                choiceType: 'option',
                chosenOptionIndex: lookupIndex
              }
            }
          })
        }
      }
    },
    applyToEntireText () {
      // (needs to have already been done! <== ) this.useNewChoice() // in case this function happens to get called first - doing it twice doesn't hurt
      var changed = this.changeAllAlikeWordsToNewNikud()
      this.showChangedNikudMessage(changed)
      document.activeElement.blur()
    },
    scrollOptionsList () {
      document.activeElement.blur()
      const listWindow = document.getElementsByClassName('options-list-container')[0]
      // console.log('this.workingOption:')
      // console.log(this.workingOption)
      if (listWindow) {
        setTimeout(() => {
          scrollParentToChild(listWindow.parentElement, listWindow.children.item(this.workingOption))
        }, 1)
      }
    },
    // methods below here are used only by the 'Pro' Nakdan
    showAccountNeeded (o, directionAttempted) {
      const popupElement = $('.nikud-options-account-needed-popup')
      popupElement.css('bottom', 'unset')
      popupElement.css('top', $('#option-row-' + o).position().top
        - (21 * 2 + 8 * 2) + 'px') // the popup's line-height is 21 and its padding is 8
      const popupText = directionAttempted === 'top' ? 'כדי להוסיף מילה למאגר, יש להתחבר לחשבון האישי.'
        : 'כדי לסמן מילה כלא רלוונטית, יש להתחבר לחשבון האישי.'
      popupElement.text(popupText)
      this.showAccountNeededPopup = true
    },
    moveShownOptionToEnd (whichEnd, o) {
      if (!(this.$store.state.isLoggedIn)) { this.showAccountNeeded(o, whichEnd); return }
      const word = this.optionsToShow[o].displayText
      var commitObj = {
        contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
      }
      const prefix = whichEnd === 'top' ? {words: 'words', entry: 'entry'} 
                                        : {words: 'negativeWords', entry: 'negativeEntry'}
      commitObj[prefix.words + 'ToAdd'] = [word] // the mutation always does any "delete"s BEFORE any "add"s
      if (this.$store.state.userDictionary[prefix.entry + 'Present'][word]) {
        commitObj[prefix.words + 'ToDelete'] = [word]
      }
      const goodOptionsLength = this.optionsToShow.length - this.relevantNegativeOptionsFromUserDictionary.length - 1
      if (whichEnd === 'bottom' && o === this.workingOption && this.localCurrentWord.choiceType === 'option') { // so a new workingOption ought to be "chosen"
        if (goodOptionsLength > this.workingOption) { // so there's an option BELOW (about to "take its place")
          this.moveToNextOption()
        } else {
          this.workingOption = Math.max(goodOptionsLength - 1, 0)
          this.useNewChoice()
        }
      }
      this.$store.commit('UPDATE_USER_DICTIONARY', commitObj)
      this.showAddedToUserDictionaryMessage(whichEnd === 'top' ? 'positive' : 'negative')
      setTimeout(() => {
        if (whichEnd === 'top') {
          this.workingOption = 0
          this.useNewChoice()
          if (this.paneOpen) this.scrollOptionsList()
        } else this.initWorkingOption()
      }, 2)
    }    
  },
  mounted: function () {
    $(document).on('click', '.click-only-here', function (e) {
      e.stopPropagation() // note: only works on elements which exist at this time! (not dict buttons)
    })
    $(document).on('click', () => {
      this.settingsOpen = false
      this.showAccountNeededPopup = false
    })
    if (this.localCurrentWordIndex > -1) {
      this.initWorkingOption()
    }
  }
}
</script>

<style scoped lang="scss">
.show-morph {
  padding-top: 13px;
  padding-bottom: 10px;
  padding-right: 7px;
  border-style: solid;
  border-width: 3px;
  border-color: #f6f6f6;
  position: absolute;
  z-index: 10;
  width: 91%;
  right: 2%;
  background-color: white;
}
.options-list-box-container {
  flex: auto;
  overflow: auto;
  font-family: Roboto, mft_narkisclassic, sans-serif;
  font-size: 20px;
  line-height: 25px;
  padding: 4px 0;
}
.list-box-container-mobile {
  font-size: 28px !important;
  line-height: 40px !important;
  text-align: center !important;
  padding-top: 12px !important;
  padding-bottom: 70px !important;
  flex: none !important;
  height: 50vh !important;
}
.list-box-container-margin {
  margin: 0 14px 10px;
}
.reg-min-height {
  height: 30vh; /* allow shrinking to less than content size */
}
.small-min-height {
  height: 62px; /* two rows */
}
.option-letter {
  font-family: Roboto;
  color: #8D8D8D;
  font-size: 13px;
  padding-left: 10px;
  display: none;
}
.options-list-box-container p {
  margin-bottom: 0;
}
.option-row {
  padding: 0 10px 0 6px;
  margin-bottom: 2px;
}
.row-mobile {
  margin-right: 15px;
  margin-left: 15px;
  border-radius: 6px;
}
.clickable-option-row, .dictionary-button {
  cursor: pointer;
}
.hovered-option {
  background-color: #f6f6f6;
}
.from-user-dict-negatives {
  color: #c0c0c0;
}
.options-list-box-container{
  .row-mobile{
    margin-right: 25px;
    margin-left: 21px;
    border-style: solid;
    border-color: transparent;
    &.highlighted-row {
      border-radius: 6px;
    }
    &.hovered-option {
       background-color: #d6ecff;
    }
  }
}
.highlighted-row {
  background-color: #d6ecff !important;
}
.framed-row {
  border-style: solid;
  border-color: #d6ecff;
}
.use-on-all-text {
  position: absolute;
  bottom: 35px;
}
.morph {
  font-size: 16px;
  @media screen and (max-width: 767px) {
    font-family: arimo;
    p {
      line-height: 30px;
    }
  }
}
.morph-switch {
  text-align: left;
  padding: 6px 14px;
  font-size: 14px;
}
.options-pane {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.options-pane-body {
  flex: auto;
  display: flex;
  flex-direction: column;
  margin-bottom: .5rem;
  height: calc(100% - 28px - .5rem); /* from App.vue: .accordion-header has height: 28px; */
}
.save-changes-footer {
  background:rgba(255,255,255,0.5);
  position: absolute;
  bottom: 0px;
  height: 70px;
  width: 100%;
  padding: 15px;
  text-align: center;
}
.accordion-toggle-btn:focus{
  box-shadow: none;
  outline: none;
}
</style>
